import UserTypes from "@wesstron/utils/Api/constants/userTypes";

const getLocalStorage = () =>
    typeof window !== "undefined" ? localStorage : null;

export const initialValue = {
    viewProperties: {
        left: false,
        right: false,
        top: true,
    },
    showBreeding: true,
    globalLoading: false,
    confirmLoading: false,
    globalLoadingText: null,
    globalLoadingTextTranslate: false,
    showFarmID: false,
};

export default function viewPropertiesReducer(state = initialValue, action) {
    switch (action.type) {
        case "HIDE_NAVIGATION": {
            return {
                ...state,
                viewProperties: {
                    left: false,
                    right: false,
                    top: false,
                },
            };
        }
        case "HIDE_SIDE_NAVIGATION": {
            return {
                ...state,
                viewProperties: {
                    left: false,
                    right: false,
                    top: true,
                },
            };
        }
        case "SHOW_NAVIGATION": {
            return {
                ...state,
                viewProperties: {
                    left: true,
                    right: true,
                    top: true,
                },
            };
        }
        case "SET_GLOBAL_LOADING": {
            return {
                ...state,
                globalLoading: action.payload,
                globalLoadingText: action.meta.text,
                globalLoadingTextTranslate: action.meta.translate || false,
            };
        }
        case "MOBILE_SET_SHOW_BREEDING": {
            return {
                ...state,
                showBreeding: action.payload,
            };
        }
        case "GET_USER_FULFILLED": {
            return {
                ...state,
                showFarmID:
                    action.payload.UserType === UserTypes.SERVICE
                        ? getLocalStorage()?.getItem?.("presentation_mode") ===
                          "true"
                        : false,
            };
        }
        case "CHANGE_FARM":
        case "USER_LOGOUT_FULFILLED": {
            return {
                ...initialValue,
                showFarmID:
                    action.type === "CHANGE_FARM"
                        ? state.showFarmID
                        : initialValue.showFarmID,
            };
        }
        case "SET_CONFIRM_LOADING": {
            return {
                ...state,
                confirmLoading: action.payload,
            };
        }
        case "GET_USER_PENDING": {
            return {
                ...state,
                globalLoadingText: "fetchingFarmData",
                globalLoadingTextTranslate: true,
            };
        }
        case "SET_GLOBAL_LOADING_TEXT": {
            return {
                ...state,
                globalLoadingText: action.payload.text,
                globalLoadingTextTranslate: action.payload.translate,
            };
        }
        case "SHOW_FARM_ID": {
            getLocalStorage()?.setItem?.(
                "presentation_mode",
                !state.showFarmID
            );
            return {
                ...state,
                showFarmID: !state.showFarmID,
            };
        }
        default:
            return state;
    }
}
